// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__YMJ2x","recordListHeader":"Sidebar_recordListHeader__NEt8m","recordCountClassName":"Sidebar_recordCountClassName__Ynoen"};